import { useMutation } from '@tanstack/react-query';
import api from '../utils/axios.ts';

export const useGenerateOTP = () => {
  return useMutation({
    mutationFn: async (payload: { username: string;}) => {
      const { data } = await api.post('/generate-otp', payload);
      return data;
    },
  });
};

export const useVerifyOTP = () => {
    return useMutation({
      mutationFn: async (payload: { username: string; otp: string }) => {
        const { data } = await api.post('/verify-otp', payload);
        return data;
      },
    });
  };

  export const useSwitchGroup = () => {
    return useMutation({
      mutationFn: async (payload: { group_id: string}) => {
        const { data } = await api.post('/switch-user-group-session', payload);
        return data;
      },
    });
  };
